export const routePermissions = {
    '/admin/entreprises': 'entreprises',
    '/admin/recruteurs': 'recruteurs',
    '/admin/utilisateurs': 'utilisateurs',
    '/admin/dashboard': 'dashboard',
    '/admin/candidatures': 'candidatures',
    '/admin/missions': 'missions',
    '/admin/cvtheque': 'cvtheque',
    '/admin/administration': 'administration',
    '/admin/email-templates': 'email-templates',
    '/admin/contact-messages': 'contact-messages',
    '/admin/logs': 'logs',
    '/admin/roles': 'roles',
    '/admin/add-talent': 'cvtheque',
    '/commercial/add-talent' : 'cvtheque',
    '/commercial/cvtheque': 'cvtheque',
    '/agent/cvtheque': 'cvtheque',
    '/agent/add-talent': 'cvtheque'

};